var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TextButton',{staticClass:"px-0",attrs:{"small":""},on:{"click":_vm.handleClick}},[_c('FavoriteIcon',{attrs:{"on":_vm.applicant.favorite}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }